<div class="container" [style.height]="contHeight">
  <div class="loader"></div>
</div>
